import actions from "./actions";

const initialState = {
  accessToken: {},
  loading: false,
  error: false,
};

export default function jwtReducer(state = initialState, action) {
  switch (action.type) {
    case actions.SET_STATE:
      return { ...state, ...action.payload };
    default:
      return state;
  }
}
